import { render, staticRenderFns } from "./ComparativoExcel.vue?vue&type=template&id=5477f49a&scoped=true&"
import script from "./ComparativoExcel.vue?vue&type=script&lang=js&"
export * from "./ComparativoExcel.vue?vue&type=script&lang=js&"
import style0 from "./ComparativoExcel.vue?vue&type=style&index=0&id=5477f49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5477f49a",
  null
  
)

export default component.exports